import axios from 'axios';

// Use local backend when running on localhost, Railway in all other cases.
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

const API_BASE_URL = isLocalhost
  ? 'http://localhost:3001/api'
  : 'https://betmimic-production.up.railway.app/api';

// Client token for API verification (prevents unauthorized API access)
const CLIENT_TOKEN = import.meta.env.VITE_BETMIMIC_CLIENT_TOKEN || 'betmimic-frontend-v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-BetMimic-Client': CLIENT_TOKEN
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const storage = localStorage.getItem('auth-storage');
  if (storage) {
    try {
      const { state } = JSON.parse(storage);
      if (state?.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
    } catch (e) {
      console.error('Error parsing auth storage:', e);
    }
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth-storage');
      window.location.href = '/login';
    }
    if (error.response?.status === 451) {
      if (typeof window !== 'undefined' && window.location.pathname !== '/legal/accept') {
        window.location.href = '/legal/accept';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
